import { Parser as HtmlToReactParser } from 'html-to-react';

const htmlToReactParser = new HtmlToReactParser();

const parseHtml = (html) => {
  return htmlToReactParser.parse(html);
};

export default parseHtml;
